import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { LogIn, AlertCircle } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="w-11 h-11 rounded-sm bg-primary flex items-center justify-center">
            <span className="text-sm font-bold text-primary-foreground font-data">PI</span>
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Portfolio Intelligence</h1>
            <p className="text-xs text-muted-foreground tracking-wide">Institutional Portfolio Intelligence</p>
          </div>
        </div>

        <Card className="border border-border bg-card shadow-2xl shadow-black/20">
          <CardContent className="p-6">
            <h2 className="text-lg font-semibold mb-6">Sign In</h2>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@institution.com"
                  className="bg-background border-border h-10"
                  required
                  data-testid="login-email"
                />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  className="bg-background border-border h-10"
                  required
                  data-testid="login-password"
                />
              </div>
              {error && (
                <div className="flex items-center gap-2 text-sm text-red-500 bg-red-500/10 border border-red-500/20 p-2.5 rounded-sm" data-testid="auth-error">
                  <AlertCircle size={14} />{error}
                </div>
              )}
              <Button type="submit" className="w-full h-10 gap-2 font-medium" disabled={loading} data-testid="login-submit">
                <LogIn size={16} />{loading ? "Signing in..." : "Sign In"}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-xs text-muted-foreground text-center mt-6 opacity-50">
          Institutional-grade real estate portfolio analytics
        </p>
      </div>
    </div>
  );
}
